module.exports = __webpack_public_path__ + "c4f4bbd2b101f31b3da0e09d04b4ba50.pdf";